<template>
  <span>{{ message }}</span>
</template>

<script>
import HOME from "@/api/sync/home";
import axios from "axios";

export default {
  name: "ldap-test",
  props: { ldap: { type: Object } },
  data() {
    return {
      state: undefined
    };
  },
  computed: {
    message: vm =>
      vm.state === undefined
        ? "正在测试LDAP连接..."
        : `LDAP连接${vm.state ? "成功" : "失败"}。`
  },
  async created() {
    this.source = axios.CancelToken.source();
    let response = await HOME.LDAP_CONNECTION_TEST(
      { ldap: this.ldap },
      { cancelToken: this.source.token }
    );
    this.state = response.data?.state;
    if (this.state === false) {
      console.log("连接失败原因：");
      console.dir(response.data.message);
    }
  },
  destroyed() {
    this.source.cancel("连接测试取消");
  }
};
</script>

<style scoped></style>
